var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignpost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.35 1.66666H7.46671C7.13337 1.66666 6.81669 1.78333 6.55835 1.98333L4.73335 3.44167C4.00002 4.025 4.00002 5.13332 4.73335 5.71665L6.55835 7.17499C6.81669 7.38332 7.14171 7.49166 7.46671 7.49166H14.35C15.1583 7.49166 15.8083 6.84166 15.8083 6.03332V3.11666C15.8083 2.31666 15.1583 1.66666 14.35 1.66666Z",
    stroke: "#0C0507",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66659 10H12.5499C12.8833 10 13.1999 10.1167 13.4583 10.3167L15.2833 11.775C16.0166 12.3583 16.0166 13.4667 15.2833 14.05L13.4583 15.5083C13.1999 15.7167 12.8749 15.825 12.5499 15.825H5.66659C4.85825 15.825 4.20825 15.175 4.20825 14.3667V11.45C4.20825 10.65 4.85825 10 5.66659 10Z",
    stroke: "#0C0507",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10V7.5",
    stroke: "#0C0507",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3333V15.8333",
    stroke: "#0C0507",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.3333H12.5",
    stroke: "#0C0507",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignpost);
export default __webpack_public_path__ + "static/media/signpost.1bc1007335da028ea9cb2196c9c7aea7.svg";
export { ForwardRef as ReactComponent };